import { Masonry } from "@mui/lab";
import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import Constants from "../../data/Constants";
import Utils from "../../utils/index";
import { isMobile } from "react-device-detect";
import { AiOutlinePlus } from "react-icons/ai";
import { TextField } from "@mui/material";
import { getGlobal, updateGlobal } from "../../services/global.service";
import FloatingContainer from "../../components/FloatingContainer";
import ThemeButton from "../../components/ThemeButton";
import MediaCard from "../../components/MediaCard";
import MediaManager from "../../components/MediaManager";
import useMediaManager from "../../hooks/useMediaManager";
import Seperator from "components/Seperator";
import moment from "moment";
import CustomNotification from "components/CustomNotification";
import { Formik } from "formik";

function Notification(props) {
  const [data, setData] = useState({
    templates: [],
  });

  const { setProgress, setToast, isRefreshed } = useOutletContext();

  useEffect(() => {
    async function api() {
      setProgress(true);
      try {
        const data = await getGlobal();
        if (data) {
          setData(data);
          setProgress(false);
        } else {
          // error

          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error

        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    api();
  }, [isRefreshed]);

  const submitHandler = async (e) => {
    setProgress(true);

    try {
      const res = await updateGlobal(data);
      setProgress(false);
      setToast({
        success: true,
        message: "Notifications Updated",
        autohide: 3000,
      });
    } catch (error) {
      setProgress(false);
      setToast({ error: true, message: Utils.CustomErrorMessage(error) });
    }
  };

  return (
    <div className="flex flex-col gap-5">
      <div className="md:m-5">
        <CustomNotification />
      </div>

      {/* <div className="text-center font-bold text-gray-400"></div> */}
      <Seperator label="Notification Templates" />

      <div>
        <div className="flex flex-col  gap-5 m-5">
          {data.templates &&
            data.templates.map((template, index) => {
              return (
                <div className="grid md:grid-cols-4 gap-10" key={index}>
                  <div className="font-bold col-span-1">
                    {template.label + ":"}
                  </div>
                  <TextField
                    multiline
                    minRows={4}
                    maxRows={10}
                    className="flex-grow col-span-3"
                    label="Message"
                    name={template.tag}
                    value={template.value}
                    onChange={(e) => {
                      const temps = data.templates;
                      temps[index] = {
                        label: template.label,
                        tag: template.tag,
                        value: e.target.value,
                      };
                      setData({ ...data, templates: temps });
                    }}
                  ></TextField>
                </div>
              );
            })}
        </div>
      </div>

      <FloatingContainer>
        <ThemeButton onClick={submitHandler}>Save Changes</ThemeButton>
      </FloatingContainer>
    </div>
  );
}

export default Notification;
